var map = {
	"./plp-promo-tile/v2/index.js": 1102,
	"./plp-promo-tile/v3/index.js": 6267,
	"./plp-promo-tile/v4/index.js": 4931,
	"./plp-promo-tile/v5/index.js": 8397,
	"./plp-promo-tile/v6/index.js": 1307,
	"./plp-promo-tile/v7/index.js": 5468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8911;